import config from '@/helpers/config'

const utils = {
    formatDate: formatDate,
    truncateText: truncateText
}

function formatDate(date) {
    let locale
    if (config.LOCALE === 'ar') {
        locale = 'ar-MA-u-nu-latn'
    } else {
        locale = 'en-US'
    }
    return new Date(date).toLocaleDateString(locale, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' })
}

function truncateText(source, size) {
    return source.length > size ? source.slice(0, size - 3) + "..." : source;
  }

export default utils